
import { Progress } from "@/components/ui/progress";
import { TableLoadingOverlay } from "@/components/ui/table-loading-overlay";

interface ImportingStageProps {
  progress: number;
  isLightMode: boolean;
  currentItem?: string;
  processingDetails?: {
    current: number;
    total: number;
    detail?: string;
  };
}

export function ImportingStage({ 
  progress, 
  isLightMode,
  currentItem,
  processingDetails
}: ImportingStageProps) {
  return (
    <div className="space-y-6 py-4">
      <div className="text-center">
        <h3 className={`text-xl font-medium mb-2 ${isLightMode ? "text-black" : "dark:text-white"}`}>Importing Data</h3>
        <p className={isLightMode ? "text-gray-600" : "dark:text-[#8E9196]"}>
          Please wait while we process your data...
        </p>
      </div>
      
      {/* Enhanced progress information */}
      <div className="space-y-4">
        <Progress value={progress} className="w-full" />
        
        <div className={`text-center text-sm ${isLightMode ? "text-gray-600" : "dark:text-[#8E9196]"}`}>
          {progress}% complete
          
          {processingDetails && (
            <div className="mt-2 text-xs">
              Processing item {processingDetails.current} of {processingDetails.total}
              {processingDetails.detail && (
                <div className="mt-1 max-w-md mx-auto truncate">{processingDetails.detail}</div>
              )}
            </div>
          )}
          
          {currentItem && (
            <div className="mt-1 text-xs max-w-md mx-auto truncate">
              Currently processing: {currentItem}
            </div>
          )}
        </div>
      </div>
      
      {/* Visual processing indicator */}
      <div className="flex justify-center mt-6">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-t-2 border-primary"></div>
      </div>
    </div>
  );
}
